<template>
  <!-- <div class="tableHome" v-bind:style="{ 'background-image': 'url(' + this.tournImage + ')' }"> -->
  <!-- <div class="tableHome" v-bind:style="{ 'background-image': 'url(' + this.tournImage + ')' }"> -->
  <div class="tableHome" v-bind:style="{ 'background-image': 'url(' + 'https://ams3.digitaloceanspaces.com/ocs-sport/mena/2026/01/BG-min.jpg' + ')' }">
   <b-container>
    <b-row class="">
      <b-col>
        <b-row class="SponsorLogoText">
          <b-col lg="12">
            <h1 class="TournName">Shaping the Future of Golf<br> in the MENA Region</h1>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
   </b-container>
  </div>
</template> 

<script>

export default {
  name: "tableHome",
  props: [
    'bkImage'
  ],
  components: {
  },
  data() {
    return {
      tournImage: ''
    };
  },
  methods: {
    TournamentBKimage: function() {
      this.tournImage = ''
      if (this.bkImage == '') {
        this.tournImage = 'https://ams3.digitaloceanspaces.com/ocs-sport/mena/2026/01/BG-min.jpg'
      } 
    },
    scroll() {
      var score = document.getElementById("download");
      score.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },
  },
  mounted() {
    this.TournamentBKimage();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tableHome.noImage {
  background-image: url('https://ams3.digitaloceanspaces.com/ocs-sport/alpstourgolf/2018/02/course.png')!important;
  background-repeat: no-repeat;
  background-size: cover;
}
.row.imagefilesPos {
  position: absolute;
  width: 100%;
  /* bot: 10em; */
  margin-top: 2em;
}
.imagefileImage {
  height: 80px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 200px;
  margin: auto;
}
.outerBorderImage {
  border-radius: 50%;
  height: 258px;
  width: 258px;
  /* border: 19px solid #ff0000; */
  /* opacity: 0.9; */
  margin-top: -32px;
  background-image: url(https://ocs-sport.ams3.cdn.digitaloceanspaces.com/alpstourgolf/2024/11/White_Circle.png);
  background-repeat: no-repeat;
  background-size: contain;
}
.outerSponImage {
  /* background-color: #fff; */
  border-radius: 50%;
  /* height: 230px;
  width: 230px; */
  height: 232px;
  width: 232px;
}
img.sponsorImage {
  /* width: 120px;
  max-width: 120px;
  position: relative;
  top: 50px;
  left: 29%;
  overflow: hidden; */
    width: 166px;
    max-width: 299px;
    position: relative;
    /* top: 70px; */
    top: 46px;
    /* top: 100px; */
    left: 20%;
    overflow: hidden;
}
img.sponsorImageNull {
  width: 227px;
  max-width: 312px;
  position: relative;
  /* top: 70px; */
  top: 5em;
  /* top: 100px; */
  left: 7%;
  overflow: hidden;
  }
.SponsorLogoText {
  margin-top: 10em;
  /* margin-top: 17em; */
}
.Allbuttons {
  /* float: right; */
  width: 244px;
  height: 50px;
  background: #fff;
  color: #fff;
  font-weight: 500;
  border-radius: 30px;
  border: 0px solid #C8102E;
  color: black;
  transition: all 0.4s ease;
  /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
  transition: all 350ms cubic-bezier(.37, 0, .63, 1);
}
.Allbuttons:hover {
  /* float: right; */
  width: 244px;
  height: 50px;
  background: #C8102E;
  color: #fff;
  font-weight: 500;
  border-radius: 30px;
  border: 1px solid #C8102E;
  transform: translateY(-10px);
}
.TournDates {
  font-size: 20px;
  color: #fff;
  font-weight: bold;
  text-align: center;
  padding-top: 3px;
  padding-bottom: 3px;
}
.dates {
  background-color: #C8102E;
  border-radius: 30px;
  width: 200px;
}
.TournName {
  font-size: 90px;
  color: #fff;
  font-weight: bold;
  text-align: center;
}
.TournCourseName {
  font-size: 40px;
  color: #fff;
  font-weight: bold;
  padding-bottom: 20px;
}
.tabs {
  /* width: auto; */
  /* width: 450px; */
  width: 536px;
  border-radius: 30px;
  /* margin-top: 5em; */
  /* margin-top: 2em; */
  margin-top: 11em;
  float: right;
  position: relative;
}

::v-deep .nav-link.active {
  color: white !important;
  background-color: #C8102E !important;
  width: 100%;
  border-color: #C8102E !important;
  height: 100%;
}

::v-deep .nav-link {
  color: black !important;
  width: 100%;
  font-size: 18pt;
  font-weight: 500;
}

::v-deep li.nav-item {
  width: 100%;
  text-align: center;
}
.tableHome {
  padding-bottom: 2%;
  background-repeat: no-repeat;
  height: 600px;
  /* height: 970px; */
  background-size: cover;
  /* margin-bottom: 4em; */
  background-position: center;
}
.mt {
  margin-top: 0 !important;
}
::v-deep .nav-tabs{
  border-bottom: 0e6;
}
::v-deep .nav-tabs .nav-link {
    margin-bottom: -1px;
    border: 1px solid transparent;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
}
@media only screen and (min-width: 1201px) {
  .below1200 {
    display: none;
  }
}
@media only screen and (max-width: 1200px) {
  .above1200 {
    display: none;
  }
  .tabs {
    width: 100%;
    border-radius: 30px;
    /* margin-top: 5em; */
    margin-top: 10em;
    float: none;
    position: relative;
  }
}
@media only screen and (max-width: 1199px) {
  .tableHome:before {
    content: "";
    position: absolute;
    overflow: hidden;
    width: 100%;
    max-height: 700px;
    height: 38em;
    top: 7.5em;
    /* background-color: rgba(0, 0, 0, 0.5); */
  }
}
@media only screen and (max-width: 768px) {
  .tableHome:before {
    content: "";
    position: absolute;
    overflow: hidden;
    width: 100%;
    /* max-height: 970px; */
    /* height: 970px; */
    height: auto;
    top: 76px;
    background-color: rgba(0, 0, 0, 0.5);
  }
}
@media only screen and (max-width: 990px) {
  .dates {
    margin: auto;
  }
  .row.imagefilesPos {
    display: none;
  }
  .tableHome {
    padding-bottom: 2%;
    background-repeat: no-repeat;
    /* height: 920px; */
    /* height: 970px; */
    height: 100%;
    background-size: cover;
    margin-bottom: 0em;
    background-position: center;
  }
  .tabs {
    width: auto;
    border-radius: 30px;
    margin-top: 4em;
    /* margin-top: 10em; */
    float: none;
    position: relative;
  }
  .outerBorderImage {
    border-radius: 50%;
    height: 190px;
    width: 190px;
    /* border: 19px solid #ff0000; */
    /* opacity: 0.9; */
    margin-top: -88px;
    background-image: url(https://ocs-sport.ams3.cdn.digitaloceanspaces.com/alpstourgolf/2024/11/White_Circle.png);
    background-repeat: no-repeat;
    background-size: contain;
    margin-left: 100px;
  }
  img.sponsorImage {
      width: 120px;
      /* max-width: 120px; */
      position: relative;
      top: 39px;
      left: -9%;
  }
  .TournDates {
    font-size: 18px;
    color: #fff;
    font-weight: bold;
    /* padding-bottom: 20px; */
  }
  .TournName {
    font-size: 30px;
    color: #fff;
    font-weight: bold;
    /* padding-bottom: 20px; */
    padding-top: 20px;
    position: relative;
    top: -46px;
    padding-top: 200px;
    padding-bottom: 200px;
  }
  .TournCourseName {
    font-size: 18px;
    color: #fff;
    font-weight: bold;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .SponsorLogoText {
    margin-top: 4em;
    text-align: center;
  }
}
@media only screen and (max-width: 480px) {
 ::v-deep .nav-link{
    font-size: 1rem;
  }
}
@media only screen and (max-width: 375px) {
  .outerBorderImage {
    border-radius: 50%;
    height: 190px;
    width: 190px;
    /* border: 19px solid #ff0000; */
    /* opacity: 0.9; */
    margin-top: -88px;
    background-image: url(https://ocs-sport.ams3.cdn.digitaloceanspaces.com/alpstourgolf/2024/11/White_Circle.png);
    background-repeat: no-repeat;
    background-size: contain;
    margin-left: 75px;
  }
}
</style>
